<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button *ngIf="isOrgAdmin" (handleClick)="create()" class="!w-[150px]"> Create </app-primary-button>
    <app-primary-button *ngIf="isOrgAdmin" (handleClick)="upload()" class="!w-[150px]"> Upload </app-primary-button>
    @if (bidSheetId) {
      <div class="download-button-container">
        @if (downloadingCsv) {
          <mat-spinner color="primary" diameter="24" mode="indeterminate" strokeWidth="3"></mat-spinner>
        } @else {
          <button
            (click)="downloadCsv()"
            class="download-button"
            data-testid="bid-sheet-download-csv"
            mat-icon-button
            matTooltip="Download bid sheet (CSV)"
            matTooltipClass="white-tooltip"
          >
            <mat-icon>download</mat-icon>
          </button>
        }
      </div>
    }

    <div class="bid-items-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
      <div>
        <mat-form-field *ngIf="selectedSortColumn" class="sort-dropdown">
          <mat-select
            (selectionChange)="onSortColumnChange($event)"
            [(value)]="selectedSortColumn"
            disableOptionCentering
            panelClass="payapp-sort-panel"
          >
            <mat-select-trigger>
              {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort:' }}
            </mat-select-trigger>
            <mat-option *ngFor="let column of sortByColumns" [value]="column">
              {{ column }}
            </mat-option>
          </mat-select>
          <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix> close</mat-icon>
        </mat-form-field>

        <div (click)="openSortDropdown($event)" *ngIf="!selectedSortColumn" class="sort-dropdown nosort">
          <div class="label text-type-8">Sort:</div>
          <mat-icon>sync_alt</mat-icon>
          <mat-form-field class="sr-sort-hidden">
            <mat-select
              #sortSelect
              (selectionChange)="onSortColumnChange($event)"
              [(value)]="selectedSortColumn"
              disableOptionCentering
              panelClass="payapp-sort-panel"
            >
              <mat-option *ngFor="let column of sortByColumns" [value]="column">
                {{ column }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
        <form [formGroup]="form" class="flex-1 min-w-0">
          <div class="search w-full">
            <mat-icon (click)="search()" svgIcon="search"></mat-icon>
            <input
              class="search-input"
              formControlName="searchText"
              matInput
              placeholder="Search by item no or description"
            />
            <mat-icon (click)="closeSearch()" *ngIf="form?.controls?.searchText?.value" svgIcon="close"></mat-icon>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="list-section">
    <div class="bid-items-list-table flex flex-col gap-[40px]">
      <div *ngIf="dataSource?.length" class="bid-items-table">
        <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
          <ng-container matColumnDef="item">
            <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Item no'" mat-header-cell>
              <span class="th-text">Item no</span>
              <span *ngIf="selectedSortColumn === 'Item no'">
                <mat-icon (click)="toggleSortDirection()" class="sort-column">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.item }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th *matHeaderCellDef mat-header-cell>Description</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11 description-cell">{{ row?.description }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Quantity'" mat-header-cell>
              <span class="th-text">Quantity</span>
              <span *ngIf="selectedSortColumn === 'Quantity'">
                <mat-icon (click)="toggleSortDirection()" class="sort-column">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.quantity }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="unit_price">
            <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Unit price'" mat-header-cell>
              <span class="th-text">Unit price</span>
              <span *ngIf="selectedSortColumn === 'Unit price'">
                <mat-icon (click)="toggleSortDirection()" class="sort-column">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.unit_price }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="uom">
            <th *matHeaderCellDef mat-header-cell>UOM</th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.uom }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="deleteBidItem(row, $event)">
                  <mat-icon svgIcon="trash"></mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns"
            [class.highlighted-row]="row === selectedRow"
            mat-row
          ></tr>
        </table>
      </div>

      <ng-container *ngIf="!dataSource?.length">
        <div class="no-data text-type-8 mt-[80px]">No data available.</div>
      </ng-container>

      <app-paginator
        *ngIf="totalRecords > 0"
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
      />
    </div>
  </div>
</div>
